<template>
  <div>
    <Drawer :drawer="drawer" :withHeader="false" :size="1177" @close="close">
      <div v-loading="loading" class="view">
        <div class="header">
          <div class="left">
            <span
              v-if="billType !== 1"
              class="title"
              :class="[active === 0 ? 'active' : '']"
              @click="changeType(0)"
            >船司轨迹</span
            >
            <span
              class="title"
              :class="[active === 1 ? 'active' : '']"
              @click="changeType(1)"
            >清关轨迹</span
            >
          </div>
          <i class="el-icon-close icon" @click="close" />
        </div>
        <div class="content">
          <div v-show="active === 0" class="table">
            <BaseTable
              v-if="height"
              :height="height"
              :tableData="tableData"
              :isPager="false"
              :border="true"
            ></BaseTable>
          </div>
          <div v-show="active === 1" class="table qg-list">
            <div class="ams">
              <div class="top">
                <div class="tips"></div>
                AMS轨迹
              </div>
              <div class="amsList">
                <div
                  v-for="(item, $index) in amsData"
                  :key="$index"
                  class="list">
                  <div
                    class="list-top"
                  >
                    <span
                      class="label"
                    >提单号：<span class="value">{{
                      item.number
                    }}</span></span
                    >
                    <span
                      class="label"
                    >类型：<span
                      :class="[
                        'value',
                        item.blType === 'M' ? 'Master' : 'House',
                      ]"
                    >{{ item.blType === "M" ? "Master" : "House" }}</span
                    ></span
                    >
                    <span
                      v-if="!rowData.type"
                      class="label"
                    >ISF On File：<span
                      class="value"
                      :style="{ color: item.isf ? '#333333' : '#FE453D' }"
                    >{{ item.isf ? "YES" : "NO" }}</span
                    ></span
                    >
                    <span
                      class="label"
                    >数量：<span class="value">{{ item.qty }}</span></span
                    >
                    <span
                      v-if="!rowData.type"
                      class="label"
                    >船名：<span class="value">{{
                      item.vesselName
                    }}</span></span
                    >
                    <span
                      v-if="!rowData.type"
                      class="label"
                    >船次：<span class="value">{{
                      item.voyageNumber
                    }}</span></span
                    >
                    <span
                      class="label"
                    >到达日期：<span class="value">{{
                      item.lastRunTime
                    }}</span></span
                    >
                  </div>
                  <div class="list-middle">
                    <div v-for="(event, index) in item.truckItems" :key="index">
                      <span class="icon">{{ event.dispositionCode }}<img src="@/assets/images/bill/qun.png" />
                      </span>
                      <span class="desc">
                        {{ event.dispositionDesc }}
                      </span>
                      <span class="quantity">
                        Quantity： {{ event.manifestQuantity }}
                      </span>
                      <span class="quantity">
                        {{ event.eventDate }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="foooter flex_c_c">
          <div v-if="!active" v-debounce-click="reloadship" class="ok flex_c_c">
            <img src="@/assets/images/bill/reload.png" />
            <span style="margin-left: 4px">刷新</span>
          </div>
          <template
            v-else>
            <div
              v-debounce-click="{ value: reload, args: [1] }"
              class="ok flex_c_c"
            >
              <img src="@/assets/images/bill/reload.png" />
              <span style="margin-left: 4px">刷新</span>
            </div>
            <div
              v-debounce-click="{ value: reSub, args: [1] }"
              class="ok flex_c_c"
              style="margin-left: 20px"
            >
              <img src="@/assets/images/bill/reload.png" />
              <span style="margin-left: 4px">重新订阅</span>
            </div>
          </template>
        </div>
      </div>
    </Drawer>
  </div>
</template>

<script>
const BaseTable = () => import('@/components/table/BaseTable')
const Drawer = () => import('@/components/drawer/Drawer')
import {
  containerEvents,
  // AMSQuery,
  manualRefreshContainerEvents,
  abiquery,
  reSubscribeClearanceTrack
} from '@/api/basic'
import { getMBLDetail } from '@/api/bill'
export default {
  components: {
    Drawer,
    BaseTable
  },
  filters: {
    dateFilete: function(date) {
      if (date) {
        return date.slice(0, date.length - 3)
      } else {
        return ''
      }
    }
  },
  props: {
    drawer: {
      type: Boolean,
      default: false
    },
    type: {
      type: Number,
      default: 0
    },
    billType: {
      type: Number,
      default: 0
    },
    rowData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      height: 0,
      active: 0,
      tableData: {
        fileds: [
          {
            filed: 'eventLocation',
            label: '轨迹发生地',
            width: '260',
            resizable: true
          },
          {
            filed: 'eventCode',
            label: '状态码',
            width: '70',
            resizable: true
          },
          {
            filed: 'eventDesc',
            label: '轨迹描述',
            width: '240',
            resizable: true
          },
          {
            filed: 'eventDate',
            label: '轨迹时间',
            width: '',
            formatter: (row) => {
              if (row.eventDate) {
                return row.eventDate.slice(0, row.eventDate.length - 3)
              } else {
                return ''
              }
            },
            resizable: true
          },
          {
            filed: 'vesselName',
            label: '船名',
            width: '120',
            resizable: true
          },
          {
            filed: 'voyageNumber',
            label: '船号',
            width: '70',
            resizable: true
          },
          {
            filed: 'createdOn',
            label: '更新时间',
            formatter: (row) => {
              if (row.createdOn) {
                return row.createdOn.slice(0, row.createdOn.length - 3)
              } else {
                return ''
              }
            },
            resizable: true
          }
        ],
        columns: [],
        total: 0
      },
      clearance: {},
      amsData: [],
      loading: false
    }
  },
  watch: {
    drawer(val) {
      if (val) {
        this.active = this.billType ? 1 : 0
        this.$nextTick(() => {
          this.height = document.querySelector('.table').offsetHeight
        })
        this.getLists()
        this.getAbiquery()
      }
    }
  },
  mounted() {},
  methods: {
    async getLists() {
      let params
      this.billType === 0 &&
        (params = {
          carrierCode: this.rowData.mblNo.slice(0, 4),
          masterBLSerial: this.rowData.mblNo.slice(
            4,
            this.rowData.mblNo.length
          )
        })
      this.billType === 1 &&
        ((params = {
          mawbPrefix: this.rowData.mblNo.slice(0, 3),
          mawbSerial: this.rowData.mblNo.slice(4, this.rowData.mblNo.length)
        }),
        (this.active = 1),
        this.reload(0))
      if (this.type === 1) {
        try {
          const result = await containerEvents(params)
          this.getContainer()
          if (result.success) {
            this.tableData.columns = result.data.events
          } else {
            this.$message.error(result.errorMessage)
          }
        } catch (error) {
          console.error(error)
        }
      }
      //  else {
      //   try {
      //     const result = await AMSQuery({
      //       ...params,
      //       mot: this.billType ? 'A' : 'O'
      //     })
      //     result.success && (this.clearance = result.data)
      //     !result.success && this.$message.error(result.errorMessage)
      //   } catch (error) {
      //     console.log(error)
      //   }
      // }
    },
    async reloadship() {
      try {
        const res = await manualRefreshContainerEvents()
        if (res.success) {
          this.$message.success('刷新成功')
          this.getLists()
        } else {
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        console.log(error)
      }
    },
    async reSub() {
      try {
        const res = await reSubscribeClearanceTrack({ mblId: this.rowData.id })
        if (res.success) {
          this.$message.success('重新订阅成功')
          this.getAbiquery()
        } else {
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        console.log(error)
      }
    },
    close() {
      this.$emit('close')
    },
    changeType(index) {
      this.active = index
      index && this.reload(0)
    },
    async getContainer() {
      try {
        const res = await getMBLDetail({
          mblId: this.rowData.id
        })
        if (res.success) {
          this.form = res.data.container
        } else {
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        console.log(error)
      }
    },
    async reload() {
      this.getAbiquery()
    },
    async getAbiquery() {
      try {
        const params = {
          mblNo: this.rowData.mblNo,
          type: 'OMS'
        }
        const res = await abiquery(params)
        if (res.success) {
          console.log(res)
          const arr = []
          if (res.data) {
            arr.push({
              number: res.data.masterBLNo,
              blType: 'M', // M 主单 H分单
              isf: res.data.isf,
              vesselName: res.data.vesselName,
              qty: res.data.quantity,
              voyageNumber: res.data.voyageNumber,
              lastRunTime: res.data.lastRunTime.split(' ')[0],
              truckItems: []
            })
            res.data.houses?.forEach((item) => {
              arr.push({
                number: item.houseNo,
                blType: 'H',
                isf: !!item.isfMatched,
                vesselName: res.data.vesselName,
                qty: res.data.manifestQuantity,
                voyageNumber: res.data.voyageNumber,
                lastRunTime: res.data.lastRunTime.split(' ')[0],
                truckItems: []
              })
            })
            res.data.events?.forEach((item) => {
              const data = arr.find(
                (a) => a.number.replace('-', '') === item.blNo && a.blType === item.blType
              )
              if (item) {
                data?.truckItems?.push({
                  dispositionCode: item.dispositionCode,
                  dispositionDesc: item.dispositionDesc,
                  manifestQuantity: item.manifestQuantity,
                  eventDate: item.eventDate
                })
              }
            })
            this.amsData = arr
          }
        } else {
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.view {
  width: 100%;
  height: 100%;
  position: relative;
  .header {
    width: 100%;
    height: 60px;
    border-bottom: 1px solid #f7f7f7;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    .left {
      flex: 1;
      display: flex;
      text-indent: 20px;
      align-items: center;
    }
    .title {
      height: 60px;
      font-size: 16px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color: #666666;
      line-height: 60px;
      cursor: pointer;
    }
    .active {
      color:  rgb(18,88,188);
    }
    .icon {
      font-size: 20px;
      margin-right: 20px;
      cursor: pointer;
    }
  }
  .content {
    width: 100%;
    height: calc(100% - 140px);
    max-height: calc(100% - 140px);
    overflow-x: hidden;
    overflow-y: auto;
    .table {
      width: 1109px;
      height: calc(100% - 80px);
      margin: 40px auto;
    }
    .qg-list {
      height: calc(100% - 60px);
      margin: 40px auto 20px;
    }
    .panel {
      width: 100%;
      box-sizing: border-box;
      .item {
        width: 260px;
        height: 30px;
        display: flex;
      }
      .label {
        width: 100px;
        height: 30px;
        background: #f7f7f7;
        border-radius: 4px 4px 4px 4px;
        opacity: 1;
        font-size: 14px;
        font-family: Microsoft YaHei-Regular, Microsoft YaHei;
        font-weight: 400;
        color: #666666;
        line-height: 30px;
        text-align: center;
      }
      span {
        display: inline-block;
        flex: 1;
        font-size: 14px;
        font-family: Microsoft YaHei-Regular, Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        line-height: 30px;
        text-indent: 15px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
    .ams {
      width: 100%;
      margin-top: 16px;
      height: calc(100% - 120px);
      .top {
        display: flex;
        width: 100%;
        height: 18px;
        font-family: Microsoft YaHei, Microsoft YaHei;
        font-weight: 400;
        font-size: 14px;
        color: #333333;
        line-height: 18px;
        .tips {
          width: 10px;
          height: 10px;
          background:  rgb(18,88,188);
          border-radius: 0px 0px 0px 0px;
          margin-top: 4px;
          margin-right: 5px;
          transform: rotate(225deg);
        }
      }
    }
  }
  .amsList {
    width: 100%;
    height: calc(100% - 34px);
    .list {
      width: 100%;
      height: calc(50% - 6px);
      background: #ffffff;
      border-radius: 6px;
      border: 1px solid #eeeeee;
      & + .list {
        margin-top: 8px;
      }
      .list-top {
        width: 100%;
        height: 55px;
        background: #f7f7f7;
        text-indent: 16px;
        font-family: Microsoft YaHei, Microsoft YaHei;
        font-weight: 400;
        font-size: 14px;
        color: #666666;
        line-height: 55px;
        .label + .label {
          margin-left: 24px;
        }
        .value {
          color: #666666;
        }
        .Master {
          width: 100px;
          height: 23px;
          background: #e8f4ff;
          border-radius: 4px 4px 4px 4px;
          font-family: Microsoft YaHei, Microsoft YaHei;
          font-weight: 400;
          font-size: 14px;
          color:  rgb(18,88,188);
          line-height: 23px;
          text-align: center;
          display: inline-block;
          text-indent: 0;
        }
        .House {
          width: 100px;
          height: 23px;
          background: #f4ecfe;
          border-radius: 4px 4px 4px 4px;
          font-family: Microsoft YaHei, Microsoft YaHei;
          font-weight: 400;
          font-size: 14px;
          color: #a55af8;
          line-height: 23px;
          text-align: center;
          display: inline-block;
          text-indent: 0;
        }
      }
      .list-middle {
        width: calc(100% - 16px);
        padding: 0 16px;
        height: calc(100% - 55px);
        max-height: calc(100% - 55px);
        overflow: hidden;
        overflow-y: auto;
        div {
          width: 100%;
          height: 16px;
          font-weight: 400;
          font-size: 12px;
          color: #333333;
          line-height: 16px;
          margin-top: 14px;
        }
        .icon {
          display: inline-block;
          width: 44px;
          height: 20px;
          background: #EDFFF8;
          border-radius: 4px 4px 4px 4px;
          font-family: Microsoft YaHei, Microsoft YaHei;
          font-weight: 400;
          font-size: 12px;
          color: #35BA83;
          line-height: 20px;
          text-align: center;
          vertical-align: 4px;
        }
        .desc {
          width: 60%;
          max-width: 60%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          display: inline-block;
        }
        .quantity {
          width: calc(20% - 22px );
          display: inline-block;
        }
      }
    }
  }
  .foooter {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 80px;
    background: #ffffff;
    box-shadow: 0px 0px 6px 1px rgba(0, 0, 0, 0.16);
    & > div {
      width: 120px;
      height: 40px;
      border-radius: 4px 4px 4px 4px;
      font-size: 14px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      cursor: pointer;
    }
    .ok {
      background:  rgb(18,88,188);
      color: #ffffff;
    }
  }
}
:deep(.el-drawer__body) {
  height: 100%;
}
</style>
